import { Controller } from "@hotwired/stimulus"

// This controller is used to toggle a css class on an element.
export default class extends Controller {
  static get values() {
    return { name: String }
  }

  toggle() {
    if (this.element.classList.contains(this.nameValue)) {
      this.element.classList.remove(this.nameValue)
    } else {
      this.element.classList.add(this.nameValue)
    }
  }
}
